/**
 * Art eines individuellen Inputs
 * (orientirert sich an den HTML input types)
 */
export enum CustomInputType {
   /**
    * Input type text
    */
   text = "text",

   /**
    * Input type checkbox
    */
   checkbox = "checkbox",
}

export const CustomInputTypeNames = {
   text: "Text",
   checkbox: "Checkbox",
};